module.exports = __webpack_public_path__ + "img/private-napolimania-tiramisu-1.b7c993a7.jpg";